module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "scroll": _vm.stickyNavigation
    }
  }, [_c('div', {
    staticClass: "container-fluid",
    class: {
      'unauth-header': !_vm.user
    },
    style: ({
      backgroundColor: _vm.getCorpHeaderColor + ' !important'
    })
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('ToneHeader', {
    staticClass: "gradient-tone-header",
    style: ({
      backgroundColor: _vm.getCorpHeaderColor + ' !important'
    }),
    attrs: {
      "hide-nav": _vm.hideNav
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "text-center min-body-height"
  }, [_c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('router-view')], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "container-fluid",
    style: ({
      backgroundColor: _vm.getCorpFooterColor
    })
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('ToneFooter', {
    staticClass: "gradient-tone-header"
  })], 1)])])])])
},staticRenderFns: []}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68dc2de0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"search":"pk_test_6pRNASCoBOKtIshFeQd4XMUh","replace":"pk_live_NgwNoBs3GAlrsSez07Zyh4Jc"}!./~/string-replace-loader?{"search":"https:/www1.dev-tonenetworks.com","replace":"https:/www.tonenetworks.com"}!./~/string-replace-loader?{"search":"https:/s3.amazonaws.com/tone-assets/app/navigation","replace":"https:/assets.tonenetworks.com/app/navigation"}!./~/string-replace-loader?{"search":"sandbox_2yn8x45w_k2v4j3d55x4gh6xz","replace":"production_6r7mxqgh_htw3nq9wp32w8h2x"}!./src/App.vue